import { HelpCircle } from "lucide-react";
import { Badge, Modal } from "antd";
import { useState } from "react";

const HowItWorks = ({ children, title, className }) => {

    const [showInstructions, setShowInstructions] = useState(false);

    return (
        <>
        <Badge
            className={`${className || "d-flex ml-auto  mr-3"}`}
            count={<HelpCircle style={{ cursor: "pointer" }} size={24} />}
            style={{
                cursor: "pointer",
                zIndex: 1
            }}
            offset={[-10, 10]}
            onClick={() => setShowInstructions(true)}
        >
            <span style={{ position: "absolute", top: 10, right: 10, zIndex: 2 }} />
        </Badge>
        <Modal
            open={showInstructions}
            onCancel={() => setShowInstructions(false)}
            footer={null}
            title={title}
        >
            {children}
        </Modal>
      </>
    );
}

export default HowItWorks;